import React from "react";

export const Offset = ({ isDisabled, offset, resultName }) => {
  if (isDisabled || !offset) return null;

  return <feOffset dx={offset.x} dy={offset.y} result={resultName} />;
};

export default Offset;
